import { useDispatch, useSelector } from 'react-redux'
import { TabCommon } from '../../../tabCommon'
import { selectReal } from '../../store/slice'
import { changeTab, selectTab } from './slice'

export const Tab = () => {
  const dispatch = useDispatch()

  const tab = useSelector(selectTab)
  const real = useSelector(selectReal)
  const firstItem = real.length ? real[0] : {}

  const onClick = (item) => {
    dispatch(changeTab(item.key))
  }

  return <TabCommon tab={tab} onClick={onClick} baseYear={firstItem.baseYear} />
}
